import styled from 'styled-components';

const Body = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

Body.displayName = 'Body';

export default Body;
